import { get } from "@/request/http";

// 获取学院的实验室信息的树
export const getLaboratoryTree = p => get("/lab/getLaboratoryTree", p);

// 获取学院的实验室列表，不分页
export const getCollegeTable = p => get("/lab/getCollegeTable", p);

// 获取菜单列表
export const getFontendFolderList = p =>
    get("/center/getFontendFolderList", p);
    // get("http://l.mools.net/index.php/center/getFontendFolderList", p);

// 获取新闻信息
export const getArticleInfo = p =>
    get("/center/getArticleInfo", p);
    // get("http://l.mools.net/index.php/center/getArticleInfo", p);

// 获取公告信息
export const getFontendNoticeInfo = p =>
    get("/center/getFontendNoticeInfo", p);
    // get("http://l.mools.net/index.php/center/getFontendNoticeInfo", p);

// 获取公告信息
export const getFontendPagesInfo = p =>
    get("/center/getFontendPagesInfo", p);
    // get("http://l.mools.net/index.php/center/getFontendPagesInfo", p);
